// extracted by mini-css-extract-plugin
export var boxesContainer = "we-help-you-module--boxes-container--NlO9d";
export var innerWrapper = "we-help-you-module--inner-wrapper--BC8m5";
export var mainTitle = "we-help-you-module--main-title--eluP1";
export var section = "we-help-you-module--section--94Glm";
export var singleBoxDescription = "we-help-you-module--single-box-description--DEtp1";